import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';


const rowHeight = '39px';
const cssPrefix = 'DataroleValuesAndSynonymsHeader';
const headerStyle =  cssClass(cssPrefix, 'header', {
  borderBottom: '1px solid rgb(235, 235, 235)',
  height: rowHeight,
  lineHeight: rowHeight,
  color: '#9B9B9B',
});

const valueStyle =  cssClass(cssPrefix, 'value', {
  paddingLeft: CommonStyles.Sizes.DefaultSpace,
  display: 'inline-block',
  width: '33%',
  boxSizing: 'border-box',
});

const synonymsStyle =  cssClass(cssPrefix, 'synonyms', {
  paddingLeft: CommonStyles.Sizes.DefaultSpace,
  display: 'inline-block',
  width: '67%',
  boxSizing: 'border-box',
});

export interface ValuesAndSynonymsHeaderProps {
}

export const ValuesAndSynonymsHeader = (props: ValuesAndSynonymsHeaderProps) => {
  return <div className={headerStyle}>
    <div className={valueStyle}>{Messages.dataRoleDefinitionSubspace_Values_Name()}</div>
    <div className={synonymsStyle}>{Messages.dataRoleDefinitionSubspace_Values_Synonyms()}</div>
  </div>;
};
